<template>
  <div class="align-middle">
    <p class="q-mb-none">{{ quantity }}</p>
    <p class="q-mb-none">
      {{
        useChangeCase((unit || tableProps.row.unit) ?? "", "capitalCase").value
      }}
    </p>
  </div>
</template>

<script setup>
import { useChangeCase } from "@vueuse/integrations/useChangeCase";
import { roundOff } from "assets/scripts/utilities/helpers";

const props = defineProps({
  col: {
    type: Object,
    default: () => {
      return {};
    },
  },
  tableProps: {
    type: Object,
    default: () => {
      return {};
    },
  },
  unit: {
    type: String,
    default: "",
  },
});

const quantity = computed(() => {
  return roundOff(props.col?.value || props.tableProps?.value || 0);
});
</script>
